import { Component, Input } from '@angular/core';

@Component({
  selector: 'multi-panel',
  templateUrl: './multi-panel.component.html',
  styleUrls: []
})
export class MultiPanel {
  @Input() header: string ='This is header'; 
  @Input() link: string;

}